module.exports = __webpack_public_path__ + "static/portfolio-phoenix-32d412cae165fa7f70d30862a85495d6.jpg";